import "./tarifsTextContent.css";

import TarifsTextCartouche from "./tarifsTextCartouche";

function TarifsTextContent({ content = [] }) {
  const cont = (
    <div className="tarifs-text-content-contenair">
      <div className="tarifs-text-content-title">
        Details du service :<br />
        <div className="tarifs-text-deroulement-separator-contenair">
          <div className="tarifs-text-deroulement-separator"></div>
        </div>
      </div>
      <div className="tarifs-text-content-list">
        {content.map((item, index) => (
          <p>{item}</p>
        ))}
      </div>
    </div>
  );
  return <TarifsTextCartouche bRight="10px">{cont}</TarifsTextCartouche>;
}
export default TarifsTextContent;
